<template>
  <div class="classification-tile">
    <div class="title-cnt">
      <h6 class="title primary">{{ $t("Classifica") }}</h6>
      <router-link to="/leaderboard" class="title-link primary">{{
        $t("Vai alla classifica")
      }}</router-link>
    </div>
    <div class="tile">
      <ul class="rank" v-if="$store.getters.getClassification.length">
        <li
          class="rank__person"
          v-for="item in $store.getters.getClassification"
          :key="item.id"
          v-bind:class="{
            primary: currentUser.id === item.userId,
            normal: currentUser.id !== item.userId
          }"
        >
          <h6 class="person__rank-number">{{ item.position }}&#176;</h6>
          <div class="person">
            <div
              class="person__image-cnt avatar"
              v-if="currentUser.id === item.userId"
            >
              <img
                v-if="currentUser.profile.avatar"
                :src="currentUser.profile.avatar"
                alt
                class="person__image"
              />
              <div
                class="no-avatar"
                :style="
                  `background: linear-gradient(to right, ${
                    $store.state.campaign.css_settings.primary
                  }, ${$store.state.campaign.css_settings.secondary}`
                "
                v-else
              ></div>
            </div>
            <div class="person__data">
              <h6 class="person__name">
                {{
                  item.userId === currentUser.id
                    ? currentUser.name
                    : `${item.first_name} ${item.last_name}`
                }}
              </h6>
              <p class="person__level">{{ item.level }}</p>
            </div>
          </div>
          <p class="person__exp">
            {{ item.points }}
            <span>{{ $t("exp") }}</span>
          </p>
        </li>
      </ul>
      <router-link to="/leaderboard" class="classification-link">
        {{ $t("Vai alla classifica") }}
        <i class="fas fa-chevron-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassificationTile",
  computed: {
    currentUser() {
      return this.$store.getters.getUser;
    }
  }
};
</script>

<style lang="scss" scoped>
h6,
p {
  margin-bottom: 0;
  text-align: left;
}
.title {
  margin-bottom: 15px;
}
.normal {
  color: #868686;

  .person__level {
    color: #868686;
  }
}
.rank {
  width: 100%;
}
.person__rank-number {
  margin-right: 15px;
  font-size: inherit;
  font-weight: bold;
}
.rank__person {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 0;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    width: 90%;
    background-color: rgba(151, 151, 151, 0.2);
  }

  &:last-of-type::before {
    content: none;
  }
}
.person {
  display: flex;
  align-items: center;
}
.person__name {
  font-weight: bold;
}
.person__image-cnt {
  width: 37px;
  height: 37px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
}
.person__level {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}
.person__exp {
  margin-left: auto;
  font-weight: bold;

  span {
    font-weight: normal;
    font-size: 12px;
  }
}
.classification-link {
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
}
</style>
